import { useEffect } from "react";
import { Link } from "../router/router";

export function NotFoundPage() {
  useEffect(() => {
    document.title = "Not found | $TISM";
  }, []);

  return (
    <section className="shell section">
      <div className="stack stack-4">
        <p className="eyebrow">404</p>
        <h1>Nothing here.</h1>
        <p className="lede">That page does not exist.</p>
        <div>
          <Link to="/" className="btn btn--ghost">
            Back to the home page
          </Link>
        </div>
      </div>
    </section>
  );
}
